import { mapGetters } from 'vuex';
import { countryCallingCodes } from '@/assets/js/country-codes';

export const misc = {
  data() {
    return {
      selectMenuPropsDefault: {
        bottom: true,
        offsetY: true,
        offsetOverflow: true,
        closeOnClick: true,
        maxHeight: '300px',
        rounded: 'lg'
      },
      resendSMSTimeDefaultValue: 40
    };
  },
  computed: {
    ...mapGetters({
      formLangKey: 'thematicCounselling/formLangKey',
      isMobileApp: 'general/isMobileApp',
      isUlHc: 'general/isUlHc'
    }),
    keyCodes() {
      return {
        backspace: 8,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        enter: 13,
        shift: 16
      };
    },
    currentPath() {
      return this.$route?.name?.split('___')[0] || null;
    },
    isPutinSucks() {
      return this.formLangKey === 'putinSucks';
    },
    putinSucksLinks() {
      return this.isPutinSucks
        ? [
            {
              vmid: 'icon',
              rel: 'icon',
              type: 'image/x-icon',
              href: '/favicon_ua.ico'
            }
          ]
        : [];
    }
  },
  methods: {
    newTab(url, focus = false, target = '_blank') {
      const tab = window.open(url, target);

      if (focus) {
        tab.focus();
      }
    },
    getLocaleText(text) {
      if (!text) {
        return '';
      }

      if (typeof text === 'string') {
        return this.$te(text, this.$i18n.locale) ? this.$t(text) : text;
      }

      let localeTextIndex = 0;
      try {
        localeTextIndex = text.findIndex(val => {
          return val.language === this.$i18n.locale;
        });

        if (localeTextIndex === -1) {
          localeTextIndex = text.findIndex(val => val.language === 'cs');
        }
      } catch {
        return text;
      }

      return text[localeTextIndex]?.text || '';
    },
    getFlagImage(countryCode) {
      if (typeof countryCode === 'string') {
        const selectedCountry = countryCallingCodes.find(
          ccc => ccc.code === countryCode.toUpperCase()
        );
        return (selectedCountry?.flagKey ?? selectedCountry?.code)?.toLowerCase();
      }
      return (countryCode.flagKey ?? countryCode.code).toLowerCase();
    },
    handleError(payload) {
      if (
        payload.error?.response?.config?.url === '/v3/fe/web-user/benefit/authorization' &&
        payload.error?.response?.status === 403 &&
        payload.error?.response?.data?.error === 'Invalid authorization parameters'
      ) {
        return;
      }

      this.$store.dispatch('errorModal/handleError', payload);
    },
    logToFlutter(data) {
      this.$logToFlutter({
        level: data.level,
        message: data.message
      });
    },
    toggleWebChat(display) {
      const daktelaDiv = document.querySelector('#daktela-web');
      if (daktelaDiv) {
        daktelaDiv.style.display = display;
      }
    }
  }
};
